module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-warehouses/master-warehouses.component.scss
// module id = ./src/app/master/master-warehouses/master-warehouses.component.scss
// module chunks = main